// Небольшая неприметная кнопка обратной связи (CASE-48). Закреплена на правом
// краю по центру высоты — не перекрывает шапку, нижнюю навигацию, FAB и
// voice-dock. Присутствует на каждом экране (монтируется в AppShell).

import type { JSX } from 'preact';
import { T, Icon } from '../../tokens';

export interface FeedbackButtonProps {
  readonly onClick: () => void;
}

export function FeedbackButton({ onClick }: FeedbackButtonProps): JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Оставить отзыв"
      title="Замечание или идея"
      style={{
        position: 'absolute',
        right: 0,
        top: '46%',
        width: 34,
        height: 44,
        borderTopLeftRadius: 12,
        borderBottomLeftRadius: 12,
        border: `1px solid ${T.border}`,
        borderRight: 'none',
        background: T.surface,
        color: T.ink2,
        boxShadow: T.shadow1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        cursor: 'pointer',
        opacity: 0.85,
        zIndex: 40,
      }}
    >
      <Icon name="edit" size={16} />
    </button>
  );
}
